const state = {
  currentGuildInfo: {}, // window.localStorage.getItem('currentGuildInfo') || [], // 当前选择的公会信息
  id: '', // window.localStorage.getItem('guildId'),
  guildPermission: ''// window.localStorage.getItem('guildPermission')
}

const mutations = {
  // 修改当前公会信息
  setGuildInfo (state, data) {
    window.localStorage.setItem('currentGuildInfo', data)
    if(data.id){
      window.localStorage.setItem('id', data.id)
    }
    state.currentGuildInfo = data
    state.id = data.id
  },
  setGuildPermission (state, data) {
    window.localStorage.setItem('guildPermission', data)
    state.guildPermission = data
  }
};

const actions = {
  // 修改当前公会信息
  setGuildInfo (context, data) {
    context.commit('setGuildInfo', data)
  },
  // 修改当前公会信息
  setGuildPermission (context, data) {
    context.commit('setGuildPermission', data)
  }
};

export default {
  state,
  mutations,
  actions
}
